import type { EmailTemplate } from "@dune/types";
import {
	Button,
	Dialog,
	DialogContent,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@dune/ui";
import { FileText } from "lucide-react";
import { useState } from "react";

interface TemplateSelectionDialogProps {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	templates: EmailTemplate[];
	isLoading: boolean;
	onSelectTemplate: (templateId: string) => void;
}

export const TemplateSelectionDialog = ({
	open,
	onOpenChange,
	templates,
	isLoading,
	onSelectTemplate,
}: TemplateSelectionDialogProps) => {
	const [selectedTemplateId, setSelectedTemplateId] = useState<string>("none");

	const handleConfirm = () => {
		if (selectedTemplateId && selectedTemplateId !== "none") {
			onSelectTemplate(selectedTemplateId);
			onOpenChange(false);
			setSelectedTemplateId("none");
		}
	};

	const handleCancel = () => {
		setSelectedTemplateId("none");
		onOpenChange(false);
	};

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogContent className="max-w-md">
				<DialogHeader>
					<DialogTitle>Utiliser un template</DialogTitle>
				</DialogHeader>
				<div className="py-4">
					<Select
						value={selectedTemplateId}
						onValueChange={setSelectedTemplateId}
						disabled={isLoading}
					>
						<SelectTrigger className="w-full">
							<SelectValue placeholder="Sélectionner un template" />
						</SelectTrigger>
						<SelectContent>
							<SelectItem value="none">Aucun template</SelectItem>
							{templates?.map((template) => (
								<SelectItem key={template.id} value={template.id}>
									<div className="flex items-center gap-2">
										<FileText size={16} />
										<span>{template.name}</span>
									</div>
								</SelectItem>
							))}
						</SelectContent>
					</Select>
				</div>
				<DialogFooter className="flex flex-col sm:flex-row gap-2">
					<Button variant="outline" onClick={handleCancel} className="flex-1">
						Annuler
					</Button>
					<Button
						onClick={handleConfirm}
						disabled={!selectedTemplateId || selectedTemplateId === "none"}
						className="flex-1"
					>
						Charger le template
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};
